var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row row-first setting" }, [
      _vm.$root.app.platform == "android"
        ? _c("div", { staticClass: "col col-100" }, [
            _c("span", { staticClass: "row__title" }, [_vm._v("Voornaam")]),
            _c("br"),
            _vm._v(
              "\n                " +
                _vm._s(_vm.data.firstname) +
                "\n            "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c("div", { staticClass: "col col-50" }, [
            _c("span", { staticClass: "row__title" }, [_vm._v("Voornaam")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c("div", { staticClass: "col col-50" }, [
            _c("span", { staticClass: "row__subtitle" }, [
              _vm._v(_vm._s(_vm.data.firstname))
            ])
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row setting" }, [
      _vm.$root.app.platform == "android"
        ? _c("div", { staticClass: "col col-100" }, [
            _c("span", { staticClass: "row__title" }, [_vm._v("Achternaam")]),
            _c("br"),
            _vm._v(
              "\n                " +
                _vm._s(_vm.data.prefix) +
                " " +
                _vm._s(_vm.data.lastname) +
                "\n            "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c("div", { staticClass: "col col-50" }, [
            _c("span", { staticClass: "row__title" }, [_vm._v("Achternaam")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c("div", { staticClass: "col col-50" }, [
            _c("span", { staticClass: "row__subtitle" }, [
              _vm._v(_vm._s(_vm.data.prefix) + " " + _vm._s(_vm.data.lastname))
            ])
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row row-last setting" }, [
      _vm.$root.app.platform == "android"
        ? _c(
            "div",
            {
              staticClass: "col col-100",
              class: { "validation-error": _vm.$v.data.company.$error }
            },
            [
              _c("span", { staticClass: "row__title" }, [
                _vm._v("Bedrijfsnaam")
              ]),
              _c("br"),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.company,
                    expression: "data.company"
                  }
                ],
                attrs: { type: "text" },
                domProps: { value: _vm.data.company },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.data, "company", $event.target.value)
                    },
                    function($event) {
                      return _vm.$v.data.company.$touch()
                    }
                  ]
                }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c("div", { staticClass: "col col-50" }, [
            _c("span", { staticClass: "row__title" }, [_vm._v("Bedrijfsnaam")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c(
            "div",
            {
              staticClass: "col col-50",
              class: { "validation-error": _vm.$v.data.company.$error }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.company,
                    expression: "data.company"
                  }
                ],
                attrs: { type: "text" },
                domProps: { value: _vm.data.company },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.data, "company", $event.target.value)
                    },
                    function($event) {
                      return _vm.$v.data.company.$touch()
                    }
                  ]
                }
              })
            ]
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row spacer" }, [_vm._v(" ")]),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _c("div", { staticClass: "row row-single setting" }, [
      _vm.$root.app.platform == "android"
        ? _c(
            "div",
            {
              staticClass: "col col-100",
              class: { "validation-error": _vm.$v.data.mobile.$error }
            },
            [
              _c("span", { staticClass: "row__title" }, [
                _vm._v("Telefoonnummer")
              ]),
              _c("br"),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.mobile,
                    expression: "data.mobile"
                  }
                ],
                attrs: { type: "text" },
                domProps: { value: _vm.data.mobile },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.data, "mobile", $event.target.value)
                    },
                    function($event) {
                      return _vm.$v.data.mobile.$touch()
                    }
                  ]
                }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c("div", { staticClass: "col col-50" }, [
            _c("span", { staticClass: "row__title" }, [
              _vm._v("Telefoonnummer")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c(
            "div",
            {
              staticClass: "col col-50",
              class: { "validation-error": _vm.$v.data.mobile.$error }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.mobile,
                    expression: "data.mobile"
                  }
                ],
                attrs: { type: "text" },
                domProps: { value: _vm.data.mobile },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.data, "mobile", $event.target.value)
                    },
                    function($event) {
                      return _vm.$v.data.mobile.$touch()
                    }
                  ]
                }
              })
            ]
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row spacer" }, [_vm._v(" ")]),
    _vm._v(" "),
    _vm._m(2),
    _vm._v(" "),
    _vm.$root.app.platform == "android"
      ? _c("div", { staticClass: "row setting" }, [
          _c(
            "div",
            {
              staticClass: "col col-50",
              class: { "validation-error": _vm.$v.data.address.$error }
            },
            [
              _c("span", { staticClass: "row__title" }, [_vm._v("Adres")]),
              _c("br"),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.address,
                    expression: "data.address"
                  }
                ],
                attrs: { type: "text" },
                domProps: { value: _vm.data.address },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.data, "address", $event.target.value)
                    },
                    function($event) {
                      return _vm.$v.data.address.$touch()
                    }
                  ]
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col col-30",
              class: { "validation-error": _vm.$v.data.number.$error }
            },
            [
              _c("br"),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.number,
                    expression: "data.number"
                  }
                ],
                attrs: { type: "text" },
                domProps: { value: _vm.data.number },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.data, "number", $event.target.value)
                    },
                    function($event) {
                      return _vm.$v.data.number.$touch()
                    }
                  ]
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col col-20",
              class: { "validation-error": _vm.$v.data.numberadd.$error }
            },
            [
              _c("br"),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.numberadd,
                    expression: "data.numberadd"
                  }
                ],
                attrs: { type: "text" },
                domProps: { value: _vm.data.numberadd },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.data, "numberadd", $event.target.value)
                    },
                    function($event) {
                      return _vm.$v.data.numberadd.$touch()
                    }
                  ]
                }
              })
            ]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.$root.app.platform == "ios"
      ? _c("div", { staticClass: "row row-first setting" }, [
          _vm._m(3),
          _vm._v(" "),
          _c("div", { staticClass: "col col-50" }, [
            _c(
              "div",
              {
                staticClass: "col col-100",
                class: { "validation-error": _vm.$v.data.address.$error }
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.data.address,
                      expression: "data.address"
                    }
                  ],
                  attrs: { type: "text" },
                  domProps: { value: _vm.data.address },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.data, "address", $event.target.value)
                      },
                      function($event) {
                        return _vm.$v.data.address.$touch()
                      }
                    ]
                  }
                })
              ]
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.$root.app.platform == "ios"
      ? _c("div", { staticClass: "row setting" }, [
          _vm._m(4),
          _vm._v(" "),
          _c("div", { staticClass: "col col-50" }, [
            _c(
              "div",
              {
                staticClass: "col col-50",
                class: { "validation-error": _vm.$v.data.number.$error }
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.data.number,
                      expression: "data.number"
                    }
                  ],
                  attrs: { type: "text" },
                  domProps: { value: _vm.data.number },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.data, "number", $event.target.value)
                      },
                      function($event) {
                        return _vm.$v.data.number.$touch()
                      }
                    ]
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "col col-50",
                class: { "validation-error": _vm.$v.data.numberadd.$error }
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.data.numberadd,
                      expression: "data.numberadd"
                    }
                  ],
                  attrs: { type: "text" },
                  domProps: { value: _vm.data.numberadd },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.data, "numberadd", $event.target.value)
                      },
                      function($event) {
                        return _vm.$v.data.numberadd.$touch()
                      }
                    ]
                  }
                })
              ]
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "row setting" }, [
      _vm.$root.app.platform == "android"
        ? _c(
            "div",
            {
              staticClass: "col col-100",
              class: { "validation-error": _vm.$v.data.zip.$error }
            },
            [
              _c("span", { staticClass: "row__title" }, [_vm._v("Postcode")]),
              _c("br"),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.zip,
                    expression: "data.zip"
                  }
                ],
                attrs: { type: "text" },
                domProps: { value: _vm.data.zip },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.data, "zip", $event.target.value)
                    },
                    function($event) {
                      return _vm.$v.data.zip.$touch()
                    }
                  ]
                }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c("div", { staticClass: "col col-50" }, [
            _c("span", { staticClass: "row__title" }, [_vm._v("Postcode")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c(
            "div",
            {
              staticClass: "col col-50",
              class: { "validation-error": _vm.$v.data.zip.$error }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.zip,
                    expression: "data.zip"
                  }
                ],
                attrs: { type: "text" },
                domProps: { value: _vm.data.zip },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.data, "zip", $event.target.value)
                    },
                    function($event) {
                      return _vm.$v.data.zip.$touch()
                    }
                  ]
                }
              })
            ]
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row row-last setting" }, [
      _vm.$root.app.platform == "android"
        ? _c(
            "div",
            {
              staticClass: "col col-100",
              class: { "validation-error": _vm.$v.data.city.$error }
            },
            [
              _c("span", { staticClass: "row__title" }, [_vm._v("Plaats")]),
              _c("br"),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.city,
                    expression: "data.city"
                  }
                ],
                attrs: { type: "text" },
                domProps: { value: _vm.data.city },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.data, "city", $event.target.value)
                    },
                    function($event) {
                      return _vm.$v.data.city.$touch()
                    }
                  ]
                }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c("div", { staticClass: "col col-50" }, [
            _c("span", { staticClass: "row__title" }, [_vm._v("Plaats")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c(
            "div",
            {
              staticClass: "col col-50",
              class: { "validation-error": _vm.$v.data.city.$error }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.city,
                    expression: "data.city"
                  }
                ],
                attrs: { type: "text" },
                domProps: { value: _vm.data.city },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.data, "city", $event.target.value)
                    },
                    function($event) {
                      return _vm.$v.data.city.$touch()
                    }
                  ]
                }
              })
            ]
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row spacer" }, [_vm._v(" ")]),
    _vm._v(" "),
    _vm._m(5),
    _vm._v(" "),
    _c("div", { staticClass: "row row-first setting" }, [
      _vm.$root.app.platform == "android"
        ? _c(
            "div",
            {
              staticClass: "col col-100",
              class: { "validation-error": _vm.$v.data.coc.$error }
            },
            [
              _c("span", { staticClass: "row__title" }, [_vm._v("KvK nummer")]),
              _c("br"),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.coc,
                    expression: "data.coc"
                  }
                ],
                attrs: { type: "text" },
                domProps: { value: _vm.data.coc },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.data, "coc", $event.target.value)
                    },
                    function($event) {
                      return _vm.$v.data.coc.$touch()
                    }
                  ]
                }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c("div", { staticClass: "col col-50" }, [
            _c("span", { staticClass: "row__title" }, [_vm._v("KvK nummer")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c(
            "div",
            {
              staticClass: "col col-50",
              class: { "validation-error": _vm.$v.data.coc.$error }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.coc,
                    expression: "data.coc"
                  }
                ],
                attrs: { type: "text" },
                domProps: { value: _vm.data.coc },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.data, "coc", $event.target.value)
                    },
                    function($event) {
                      return _vm.$v.data.coc.$touch()
                    }
                  ]
                }
              })
            ]
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row setting" }, [
      _vm.$root.app.platform == "android"
        ? _c(
            "div",
            {
              staticClass: "col col-100",
              class: { "validation-error": _vm.$v.data.companyemail.$error }
            },
            [
              _c("span", { staticClass: "row__title" }, [
                _vm._v("Factuur e-mail")
              ]),
              _c("br"),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.companyemail,
                    expression: "data.companyemail"
                  }
                ],
                attrs: { type: "text" },
                domProps: { value: _vm.data.companyemail },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.data, "companyemail", $event.target.value)
                    },
                    function($event) {
                      return _vm.$v.data.companyemail.$touch()
                    }
                  ]
                }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c("div", { staticClass: "col col-50" }, [
            _c("span", { staticClass: "row__title" }, [
              _vm._v("Factuur e-mail")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c(
            "div",
            {
              staticClass: "col col-50",
              class: { "validation-error": _vm.$v.data.companyemail.$error }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.companyemail,
                    expression: "data.companyemail"
                  }
                ],
                attrs: { type: "text" },
                domProps: { value: _vm.data.companyemail },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.data, "companyemail", $event.target.value)
                    },
                    function($event) {
                      return _vm.$v.data.companyemail.$touch()
                    }
                  ]
                }
              })
            ]
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row setting row-last" }, [
      _vm.$root.app.platform == "android"
        ? _c(
            "div",
            {
              staticClass: "col col-100",
              class: { "validation-error": _vm.$v.data.voicemailEmail.$error }
            },
            [
              _c("span", { staticClass: "row__title" }, [
                _vm._v("Voicemail e-mail")
              ]),
              _c("br"),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.voicemailEmail,
                    expression: "data.voicemailEmail"
                  }
                ],
                attrs: { type: "text" },
                domProps: { value: _vm.data.voicemailEmail },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.data, "voicemailEmail", $event.target.value)
                    },
                    function($event) {
                      return _vm.$v.data.voicemailEmail.$touch()
                    }
                  ]
                }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c("div", { staticClass: "col col-50" }, [
            _c("span", { staticClass: "row__title" }, [
              _vm._v("Voicemail e-mail")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c(
            "div",
            {
              staticClass: "col col-50",
              class: { "validation-error": _vm.$v.data.voicemailEmail.$error }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.voicemailEmail,
                    expression: "data.voicemailEmail"
                  }
                ],
                attrs: { type: "text" },
                domProps: { value: _vm.data.voicemailEmail },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.data, "voicemailEmail", $event.target.value)
                    },
                    function($event) {
                      return _vm.$v.data.voicemailEmail.$touch()
                    }
                  ]
                }
              })
            ]
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row spacer" }, [_vm._v(" ")]),
    _vm._v(" "),
    _vm._m(6),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row setting row-single has-subitem" },
      [
        _c("router-link", { attrs: { to: "/password-edit" } }, [
          _vm.$root.app.platform == "android"
            ? _c("div", { staticClass: "col col-100" }, [
                _c("span", { staticClass: "row__title" }, [
                  _vm._v("Wachtwoord wijzigen")
                ]),
                _c("br")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.$root.app.platform == "ios"
            ? _c("div", { staticClass: "col col-100" }, [
                _c("span", { staticClass: "row__title" }, [
                  _vm._v("Wachtwoord wijzigen")
                ])
              ])
            : _vm._e()
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "row spacer" }, [_vm._v(" ")]),
    _vm._v(" "),
    _vm._m(7),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "row setting row-single row-last",
        on: {
          click: function($event) {
            return _vm.showIban(_vm.data.iban)
          }
        }
      },
      [
        _vm.$root.app.platform == "android"
          ? _c(
              "div",
              {
                staticClass: "col col-100",
                class: { "validation-error": _vm.$v.data.iban.$error }
              },
              [
                _c("span", { staticClass: "row__title" }, [
                  _vm._v("Bankrekening")
                ]),
                _c("br"),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm._f("truncate")(_vm.data.iban, 12)) +
                    "\n            "
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.$root.app.platform == "ios"
          ? _c("div", { staticClass: "col col-50" }, [
              _c("span", { staticClass: "row__title" }, [
                _vm._v("Bankrekening")
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.$root.app.platform == "ios"
          ? _c(
              "div",
              {
                staticClass: "col col-50",
                class: { "validation-error": _vm.$v.data.iban.$error }
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm._f("truncate")(_vm.data.iban, 12)) +
                    "\n            "
                )
              ]
            )
          : _vm._e()
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "row spacer" }, [_vm._v(" ")]),
    _vm._v(" "),
    _vm._m(8),
    _vm._v(" "),
    _c("div", { staticClass: "row setting row-single row-last" }, [
      _vm.$root.app.platform == "android"
        ? _c(
            "div",
            {
              staticClass: "col col-100",
              class: { "validation-error": _vm.$v.data.ponumber.$error }
            },
            [
              _c("span", { staticClass: "row__title" }, [_vm._v("PO-nummer")]),
              _c("br"),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.ponumber,
                    expression: "data.ponumber"
                  }
                ],
                attrs: { type: "text" },
                domProps: { value: _vm.data.ponumber },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.data, "ponumber", $event.target.value)
                    },
                    function($event) {
                      return _vm.$v.data.ponumber.$touch()
                    }
                  ]
                }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c("div", { staticClass: "col col-50" }, [
            _c("span", { staticClass: "row__title" }, [_vm._v("PO-nummer")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c(
            "div",
            {
              staticClass: "col col-50",
              class: { "validation-error": _vm.$v.data.ponumber.$error }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.ponumber,
                    expression: "data.ponumber"
                  }
                ],
                attrs: { type: "text" },
                domProps: { value: _vm.data.ponumber },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.data, "ponumber", $event.target.value)
                    },
                    function($event) {
                      return _vm.$v.data.ponumber.$touch()
                    }
                  ]
                }
              })
            ]
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row spacer" }, [_vm._v(" ")]),
    _vm._v(" "),
    _c("div", { staticClass: "row row-button" }, [
      _c("div", { staticClass: "col col-100" }, [
        _c("button", { staticClass: "button", on: { click: _vm.submit } }, [
          _vm._v("Gegevens opslaan")
        ])
      ])
    ]),
    _vm._v(" "),
    _vm.$root.app.platform == "ios" && _vm.data.hasSubscription == false
      ? _c("div", { staticClass: "row spacer" }, [_vm._v(" ")])
      : _vm._e(),
    _vm._v(" "),
    _vm.data.hasSubscription == false
      ? _c(
          "div",
          {
            staticClass: "row row-button",
            class: { explanation: _vm.data.schedule }
          },
          [
            !_vm.data.schedule
              ? _c("div", { staticClass: "col col-100" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button",
                      on: { click: _vm.remove_account }
                    },
                    [_vm._v("Verwijder mijn account")]
                  )
                ])
              : _c("div", { staticClass: "col col-100" }, [
                  _vm._v(
                    "\n                Je hebt aangegeven het account te willen verwijderen. Het account wordt "
                  ),
                  _c("b", [_vm._v("definitief verwijderd")]),
                  _vm._v(
                    " op " +
                      _vm._s(_vm.data.schedule.scheduleTime) +
                      ".\n            "
                  )
                ])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.$root.app.platform == "ios"
      ? _c("div", { staticClass: "row spacer" }, [_vm._v(" ")])
      : _vm._e(),
    _vm._v(" "),
    _vm.requestSend
      ? _c("div", { staticClass: "row row-last setting explanation notice" }, [
          _vm._m(9)
        ])
      : _c("div", { staticClass: "row row-button" }, [
          _c("div", { staticClass: "col col-100" }, [
            _c(
              "button",
              { staticClass: "button", on: { click: _vm.export_data } },
              [_vm._v("Exporteer persoonlijke data ")]
            )
          ])
        ]),
    _vm._v(" "),
    _vm.$root.app.platform == "ios"
      ? _c("div", { staticClass: "row spacer" }, [_vm._v(" ")])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row head" }, [
      _c("div", { staticClass: "col col-100" }, [_vm._v("Tenaamstelling")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row head" }, [
      _c("div", { staticClass: "col col-100" }, [_vm._v("Contactgegevens")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row head" }, [
      _c("div", { staticClass: "col col-100" }, [_vm._v("Adresgegevens")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col col-50" }, [
      _c("span", { staticClass: "row__title" }, [_vm._v("Straat")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col col-50" }, [
      _c("span", { staticClass: "row__title" }, [_vm._v("Huisnummer")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row head" }, [
      _c("div", { staticClass: "col col-100" }, [_vm._v("Bedrijfsgegevens")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row head" }, [
      _c("div", { staticClass: "col col-100" }, [
        _vm._v("Wachtwoord instellingen")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row head" }, [
      _c("div", { staticClass: "col col-100" }, [_vm._v("Betaalgegevens")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row head" }, [
      _c("div", { staticClass: "col col-100" }, [_vm._v("Factuurgegevens")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col col-100" }, [
      _vm._v("\n                Je verzoek voor een "),
      _c("b", [_vm._v("export van persoonlijke data")]),
      _vm._v(
        " is ingediend. Je ontvangt van ons direct een mail om het bestand te downloaden.\n            "
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d0444a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d0444a6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Account.vue
// module id = null
// module chunks = 